module.exports = __webpack_public_path__ + "static/LamarLogoVarsity-5d1cf0e5e637639c9896e869ac3fac62.png";